import { createQueryKeyStore } from '@lukemorales/query-key-factory';
import { AxiosInstance } from 'axios';

import { API_PREFIX_ADMIN } from '../../../constants.ts';

import { TAdminUsersPayload, TAdminUsersResponse } from './types.ts';

export class AdminApiUsersService {
    #QUERY_KEYS = createQueryKeyStore({
        users: {
            list: (payload: TAdminUsersPayload) => ({
                queryKey: ['admin-users', payload],
                queryFn: () => this.#getPaginatedUsers(payload),
            }),
        },
    });

    constructor(private api: AxiosInstance) {
        this.api = api;
    }

    getUsers(payload: TAdminUsersPayload) {
        return this.#QUERY_KEYS.users.list(payload);
    }

    async #getPaginatedUsers(payload: TAdminUsersPayload): Promise<TAdminUsersResponse> {
        const { data } = await this.api.get<TAdminUsersResponse>(API_PREFIX_ADMIN + '/users', {
            params: payload,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return data;
    }
}
